import { UtilityService } from '@eforall/common';
import { FilterOperator, GridColumn, buildColumn } from '@eforall/dashboard';
import { ContactRequest } from '@interfaces';
import { AppService } from '../../../../../services';


export function getColumns(util: UtilityService, app: AppService) {

	const columns: GridColumn<ContactRequest, unknown>[] = [
		buildColumn(util, 'Id', row => row.lastContactStaffId, { header: 'lastContactStaffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.lastContactStaffId), { header: 'Last Contacted By', width: 80 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.lastContactUTC), { header: 'Last Contact Date', width: 70 }),
		buildColumn(util, 'Number', row => row.person.id, { width: 40, header: 'Person Id', hidden: true }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.requestedDateUTC), { width: 80, headerTooltip: 'Requested Date', header: 'Date' }),
		buildColumn(util, 'FullName', row => row.person.fullName, { header: 'Name' }),
		buildColumn(util, 'FirstName', row => row.person.firstName, { header: 'First Name', hidden: true }),
		buildColumn(util, 'LastName', row => row.person.lastName, { header: 'Last Name', hidden: true }),
		buildColumn(util, 'Number', row => row.requestCategoryId, { width: 50, header: 'Category Id', hidden: true }),
		buildColumn(util, 'Text', row => row.categoryName, { width: 100, header: 'Category Name' }),
		buildColumn(util, 'YesNo', row => row.responseRequested, { width: 70, header: 'Response Requested' }),
		buildColumn(util, 'YesNo', row => row.closed, {
			width: 60, header: 'Closed', filterType: 'boolean',
			filter: { operator: FilterOperator.EqualTo, value: false },
		}),
		buildColumn(util, 'Number', row => row.engagementId, { header: 'Engagement Id', hidden: true }),
	];

	return columns;

}